import { FC } from "react"
import DoubleButton from "../../components/generic/buttons/DoubleButton"
import IconTopButton from "../../components/generic/buttons/IconTopButton"

import { GCRMode } from "../../common/transaction"
import { BtnText, FlightText } from "../../common/text"

interface IAddBtn {
  isGabaPage?: boolean
  isHandlingPage?: boolean
  icon: string
  doubleIcon?: string
  doubleIconName?: string
  handleAddFlight: (flightMode: string, gcrMode?: GCRMode) => void
  disabled: boolean
  title: string
  content: string
  flightMode?: string
  hideAcReg?: boolean
}
const AddFlightBtn: FC<IAddBtn> = ({
  isGabaPage,
  isHandlingPage,
  icon,
  doubleIcon,
  handleAddFlight,
  disabled,
  flightMode,
  title,
  content,
  hideAcReg,
  doubleIconName
}) => {
  return (
    <div className="ocs-mr-16">
      <div className="d-flex flex-column align-items-center">
        {(!isGabaPage && !isHandlingPage) || hideAcReg ? (
          <IconTopButton
            onClick={() => handleAddFlight(flightMode)}
            icon={icon}
            type="button"
            className="w-100p"
            disabled={disabled}
            doubleIconName={doubleIconName}
          >
            {content}
          </IconTopButton>
        ) : (
          <DoubleButton
            buttons={[
              {
                onClick: () => handleAddFlight(flightMode, GCRMode.FLT),
                btnText: BtnText.flightNo,
                editMode: BtnText.add
              },
              {
                onClick: () => handleAddFlight(flightMode, GCRMode.REG),
                btnText: FlightText.acReg,
                editMode: BtnText.add
              }
            ]}
            title={title}
            icon={icon}
            doubleIcon={doubleIcon}
            type="button"
          />
        )}
      </div>
    </div>
  )
}

export default AddFlightBtn
